module.exports = __webpack_public_path__ + "img/daily.f2d9972d.svg";